export default __webpack_public_path__ + "static/aed_w.aff774638e0a24b8b856fa5b9db006d1.svg";